import { useEffect } from 'react';

export const makeUseOnStorageChange =
  (store: Storage) =>
  (storageKey: string, callback: (newValue: string | null, oldValue: string | null) => void) => {
    useEffect(() => {
      const onStorageChange = (e: StorageEvent): void => {
        const { key, storageArea, newValue, oldValue } = e;
        if (storageArea !== store || key !== storageKey) {
          return;
        }
        callback(newValue, oldValue);
      };

      window.addEventListener('storage', onStorageChange);
      return () => {
        window.removeEventListener('storage', onStorageChange);
      };
    }, [storageKey, callback]);
  };

export const useOnLocalStorageChange = makeUseOnStorageChange(localStorage);
export const useOnSessionStorageChange = makeUseOnStorageChange(sessionStorage);
